<template>
  <!-- FT-195: секрет интеграции «только на запись». Поле не показывает сохранённое: пустое значение при
       сохранении означает «не менять», заданный секрет отмечен подсказкой; стереть — кнопкой «Удалить ключ». -->
  <v-text-field
    :value="value"
    :label="label"
    :placeholder="isSet ? $t('integration_secrets.set_placeholder') : placeholder"
    :persistent-placeholder="isSet"
    :type="visible ? 'text' : 'password'"
    :dense="dense"
    :disabled="disabled"
    :class="fieldClass"
    :data-testid="testid"
    outlined
    hide-details
    autocomplete="new-password"
    @input="$emit('input', $event)"
  >
    <template v-slot:append>
      <v-icon v-if="value" @click="visible = !visible">{{ visible ? "mdi-eye-off" : "mdi-eye" }}</v-icon>
      <v-icon v-if="saveIcon" :color="isSet || value ? 'green' : 'grey'" class="ml-1" cursor="pointer" @click="$emit('save')">
        mdi-content-save-outline
      </v-icon>
    </template>
    <template v-slot:append-outer>
      <v-btn
        v-if="isSet && !disabled"
        icon
        small
        color="error"
        :title="$t('integration_secrets.clear')"
        :data-testid="testid ? `${testid}-clear` : null"
        @click="$emit('clear')"
      >
        <v-icon small>mdi-delete-outline</v-icon>
      </v-btn>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: "IntegrationSecretField",
  props: {
    value: { type: String, default: "" },
    label: { type: String, required: true },
    placeholder: { type: String, default: "" },
    isSet: { type: Boolean, default: false },
    saveIcon: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    fieldClass: { type: String, default: "" },
    testid: { type: String, default: null },
  },
  data() {
    return { visible: false };
  },
};
</script>
